@let isShake = isShakeTabs.$ | async;

<div
    class="bazis-collapsible-to-more"
    [class.bazis-collapsible-to-more--opacity]="isShake"
    [class.bazis-collapsible-to-more--notabs]="!tabList || !tabList.length"
    #wrapper
>
    @if (isShake) {
        <div class="bazis-collapsible-to-more__shake">
            <bazis-skeleton></bazis-skeleton>
        </div>
    }
    <div class="bazis-collapsible-to-more__start">
        <bazis-tabs
            #bazisTabs
            [tabList]="tabList"
            [tabTemplate]="tabTemplate"
            [selectedTab]="selectedTab.$ | async"
            [hideByZeroCount]="hideByZeroCount"
            [hasMore]="hasMore$ | async"
            [needScroll]="needScroll"
            [moreInsideItemsCounter]="moreInsideItemsCounter"
            adaptiveMode="useMore"
            (selectedTabChange)="changeSelectedTab($event)"
        ></bazis-tabs>

        <ng-content select="start"></ng-content>
    </div>
    <div
        class="bazis-collapsible-to-more__end"
        #endPart
    >
        <ng-content select="end"></ng-content>
    </div>
</div>

@let observeElementResizing = observeElementResizing$ | async;
